/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export interface UsageAggregateItem {
  model_name: string;
  prompt_tokens: Int64;
  completion_tokens: Int64;
  total_tokens: Int64;
  calls: Int64;
  credential_id?: Int64;
  credential_name?: string;
  end_user_id?: string;
  time_bucket?: string;
  agent_id?: Int64;
  agent_name?: string;
}

export interface AggregateUsageRequest {
  space_id?: Int64;
  source?: number;
  credential_id?: Int64;
  start?: Int64;
  end?: Int64;
  model_name?: string;
  end_user_id?: string;
  biz_type?: number;
  group_by?: string;
  agent_id?: Int64;
}

export interface AggregateUsageResponseData {
  items: UsageAggregateItem[];
  total_tokens: Int64;
}

export interface AggregateUsageResponse {
  code: number;
  msg: string;
  data: AggregateUsageResponseData;
}

export interface UsageRecordItem {
  id: Int64;
  model_name: string;
  source: number;
  credential_id: Int64;
  end_user_id?: string;
  prompt_tokens: Int64;
  completion_tokens: Int64;
  total_tokens: Int64;
  biz_type: number;
  created_at: Int64;
  agent_id?: Int64;
  agent_name?: string;
}

export interface ListUsageRequest {
  space_id?: Int64;
  source?: number;
  credential_id?: Int64;
  model_name?: string;
  page?: Int64;
  size?: Int64;
  end_user_id?: string;
  biz_type?: number;
  start?: Int64;
  end?: Int64;
  agent_id?: Int64;
}

export interface ListUsageResponseData {
  items: UsageRecordItem[];
  has_more?: boolean;
}

export interface ListUsageResponse {
  code: number;
  msg: string;
  data: ListUsageResponseData;
}

export interface UsageFacetItem {
  value: string;
  label: string;
}

export interface UsageFacetRequest {
  space_id?: Int64;
  start?: Int64;
  end?: Int64;
}

export interface UsageFacetResponseData {
  models: UsageFacetItem[];
  oauth_apps: UsageFacetItem[];
  end_users: UsageFacetItem[];
  agents: UsageFacetItem[];
}

export interface UsageFacetResponse {
  code: number;
  msg: string;
  data: UsageFacetResponseData;
}

export interface ExportUsageRequest {
  space_id?: Int64;
  source?: number;
  credential_id?: Int64;
  model_name?: string;
  end_user_id?: string;
  biz_type?: number;
  start?: Int64;
  end?: Int64;
  agent_id?: Int64;
}

export default class UsageService<T> {
  private request: any = () => {
    throw new Error('UsageService.request is undefined');
  };
  private baseURL: string | ((path: string) => string) = '';

  constructor(options?: {
    baseURL?: string | ((path: string) => string);
    request?<R>(
      params: {
        url: string;
        method: 'GET' | 'DELETE' | 'POST' | 'PUT' | 'PATCH';
        data?: any;
        params?: any;
        headers?: any;
      },
      options?: T,
    ): Promise<R>;
  }) {
    this.request = options?.request || this.request;
    this.baseURL = options?.baseURL || '';
  }

  private genBaseURL(path: string) {
    return typeof this.baseURL === 'string'
      ? this.baseURL + path
      : this.baseURL(path);
  }

  AggregateUsage(
    req: AggregateUsageRequest,
    options?: T,
  ): Promise<AggregateUsageResponse> {
    const url = this.genBaseURL('/api/permission_api/usage/aggregate');
    const method = 'GET';
    const params = {
      space_id: req['space_id'],
      source: req['source'],
      credential_id: req['credential_id'],
      start: req['start'],
      end: req['end'],
      model_name: req['model_name'],
      end_user_id: req['end_user_id'],
      biz_type: req['biz_type'],
      group_by: req['group_by'],
      agent_id: req['agent_id'],
    };
    return this.request({ url, method, params }, options);
  }

  ListUsage(
    req: ListUsageRequest,
    options?: T,
  ): Promise<ListUsageResponse> {
    const url = this.genBaseURL('/api/permission_api/usage/list');
    const method = 'GET';
    const params = {
      space_id: req['space_id'],
      source: req['source'],
      credential_id: req['credential_id'],
      model_name: req['model_name'],
      page: req['page'],
      size: req['size'],
      end_user_id: req['end_user_id'],
      biz_type: req['biz_type'],
      start: req['start'],
      end: req['end'],
      agent_id: req['agent_id'],
    };
    return this.request({ url, method, params }, options);
  }

  UsageFacet(
    req: UsageFacetRequest,
    options?: T,
  ): Promise<UsageFacetResponse> {
    const url = this.genBaseURL('/api/permission_api/usage/facet');
    const method = 'GET';
    const params = {
      space_id: req['space_id'],
      start: req['start'],
      end: req['end'],
    };
    return this.request({ url, method, params }, options);
  }
}
